module.exports = __webpack_public_path__ + "img/预约体测.6cdc9cf1.png";